module.exports = __webpack_public_path__ + "img/expostyle_9289_petunia.66555e22.jpg";